export function createCsv(dataList, attrSequence) {
  const csvRows = dataList.map((data) => {
    return attrSequence.map((attr) => data[attr]);
  });

  return csvRows.map((row) => row.join(",")).join("\n");
}
